"use strict";

exports.__esModule = true;
exports.default = wrap;
var _partial = _interopRequireDefault(require("./partial.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// Returns the first function passed as an argument to the second,
// allowing you to adjust arguments, run code before and after, and
// conditionally execute the original function.
function wrap(func, wrapper) {
  return (0, _partial.default)(wrapper, func);
}